import { useSelector } from 'react-redux';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Map from '../../components/google/maps/Map';
import { selectors } from '../../store/dux/field-boundary-management-dux';
import { FullScreenDialog } from '../../components/FullScreenDialog';
import { DialogTitle } from '../../components/DialogTitle';
import { BoundaryEditControls } from './BoundaryEditControls';
import { Acres } from '../../components/Acres';
import { useLayers } from './use-layers';
import { useContext } from './context';
import { useMapProperties } from '../../components/google/maps/use-map-properties';

export default function BoundaryEditorDialog(props) {
  const { field, growerId, close, save } = props;
  const boundary = useSelector(selectors.currentBoundary);
  const isWorking = useSelector(selectors.isWorking);
  const { layers } = useLayers();
  const { map } = useContext();
  const mapProperties = useMapProperties(map);

  return (
    <FullScreenDialog>
      <DialogTitle
        title={`${field.id ? 'Edit' : 'Add'} Boundary - ${field.fieldName}`}
        details={buildAcres()}
        onClose={close}
      />
      <DialogContent sx={{ p: 0 }}>{buildMap()}</DialogContent>
      <DialogActions>
        <Button
          disabled={isWorking}
          variant="contained"
          color="dark"
          onClick={close}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={!boundary?.properties?.acres}
          variant="contained"
          onClick={onSaveClick}
          loading={isWorking}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </FullScreenDialog>
  );

  function buildAcres() {
    if (!boundary?.properties?.acres) return null;

    return (
      <Box sx={{ minWidth: 150, display: 'inline-block' }}>
        {`Acres: `}
        <Acres acres={boundary.properties.acres} precision={1} />
      </Box>
    );
  }

  function onSaveClick() {
    save({ ...field, ...boundary.properties, shape: boundary.geometry });
  }

  function buildMap() {
    if (!mapProperties?.extent) return null;

    return (
      <Map
        working={isWorking}
        center={mapProperties.center}
        zoom={mapProperties.zoom}
        layers={layers}
        filters={{ growerId }}
      >
        <BoundaryEditControls field={field} />
      </Map>
    );
  }
}
